import { injectionSDK } from "./core/inject";
import { getDsl, getSDK, pv } from "./core/request";
import { evalFN } from "./core/utils";
import { CFG, DSL, PageDetail, RENDER, SdkDetail } from "./types/globals";
import DB from './core/db'
import { DEFAULT_CONFIG } from './config';
import { log } from './core/log';
import { dateFormat } from './core/utils';
const db = new DB({
  dbName: 'Altihex',
  tableName: 'AltihexData',
  tableCfg: {
    keyPath: 'id'
  }
})

class AltihexSDK {
  private db: DB
  private cfg: CFG
  private Render!: RENDER;
  constructor(cfg: CFG = {}) {
    this.cfg = Object.assign({}, DEFAULT_CONFIG, cfg)
    console.log(
      "%c得物前端平台团队欢迎您！",
      " text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);font-size:20px"
    );
    console.log(
      "%c欢迎使用翱翔天城，翱翔天城全体开发24小时为您竭诚服务！！",
      " text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);font-size:16px"
    );
    console.log("%c如果您想加入我们，请毫不犹疑的联系 黄文全！！7*24 TEL: 16601772672", " color:red;font-size:12px");
    log('SDK编译时间', dateFormat('YYYY-mm-dd HH:MM', new Date(process.env.TIME as any)))
    this.db = db
  }

  injection({ sdkCss, sdkJs, sdkVersion, schemaJson, cdnKey, updatedAt, id, sdkGlobalConfig, dependency}: PageDetail) {
    this.cfg.page = {
      cdnKey,
      updatedAt,
      id,
      sdkCss,
      sdkJs,
      sdkVersion,
    }
    if (dependency) {
      this.cfg.dependenciesAll = dependency
    }
    return new Promise((resolve, reject) => {
      injectionSDK(sdkJs, sdkCss, sdkVersion, this.db).then((e) => {
        try {
          const dsl: DSL = evalFN(`return ${schemaJson}`)() || {}
          const globalConfig: object =  evalFN(`return ${sdkGlobalConfig}`) () || {}
          if(globalConfig && Object.prototype.toString.call(globalConfig) === '[object Object]'){
            this.cfg = Object.assign({}, globalConfig, this.cfg)
          }
          const version = sdkVersion.replace(/\./g, '_')
          this.Render = window[`altihex${version}`].Render(dsl, this.cfg)
          log(this.cfg)
          this.cfg.update?.(this.Render)
          pv(this.cfg)

          resolve(this.Render)
        } catch (error) {
          log.error('SDK加载出错拉！！', error)
          reject()
        }

      }).catch(reject)
    })
  }

  preview(dsl: DSL, { js, css, version }: SdkDetail)  {
    this.cfg.preivew = true
    return new Promise((resolve, reject) => {
      injectionSDK(js, css, version, this.db).then((e) => {
        try {
          const sdkVersion = version.replace(/\./g, '_')
          log('预览模式', sdkVersion, this.cfg)
          this.Render = window[`altihex${sdkVersion}`].Render(dsl, this.cfg)
          this.cfg.update?.(this.Render)
          resolve(this.Render)
        } catch (error) {
          log.error('预览出错拉！！', error)
          reject()
        }

      }).catch(reject)
    })
  }

  run(id: DSL | string, cfg: CFG = {}) {
    this.cfg = Object.assign({}, this.cfg, cfg)
    return new Promise((resolve, reject) => {
      if (typeof id === 'string') {
        getDsl(id).then(data => this.injection(data)).then(resolve)
        .catch(reject)
      } else if (this.cfg.sdkVersion) {
        getSDK(this.cfg.sdkVersion).then(data => this.preview(id, data)).then(resolve)
        .catch(reject)
      } else {
        log.error('sdkVersion 必填')
      }
    })
  }

}

export default AltihexSDK

